import 'ui-theme/variables/js/photo-grid-variables';

UX.grid.articleLg = 1320;
